import { render, staticRenderFns } from "./FileShow.vue?vue&type=template&id=3277e7bc&"
import script from "./FileShow.vue?vue&type=script&lang=js&"
export * from "./FileShow.vue?vue&type=script&lang=js&"
import style0 from "./FileShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports